import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  alignItems: 'flex-start'
});

export const IconContainer = styled('a')(({ theme }: { theme?: Theme }) => ({
  background: theme.palette.primary.main,
  lineHeight: 0,
  borderRadius: '50%',
  width: '60px',
  minWidth: '60px',
  height: '60px',
  textAlign: 'center',
  marginRight: '20px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  '.catLoveAndRelationships': {
    marginTop: '1px'
  }
}));

export const Text = styled('div')({
  display: 'inline-block'
});

export const Title = styled('a')(({ theme }: { theme?: Theme }) => ({
  color: theme.palette.primary.dark,
  fontWeight: 500,
  fontSize: '16px',
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.primary.main
  }
}));

export const Description = styled('div')({
  fontSize: '16px',
  fontWeight: 400,
  color: '#09292f'
});

export const AdvisorCategoriesContainer = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    '& .categories-container': {
      marginTop: '30px',
      '& .category-item-container': {
        marginBottom: '20px'
      }
    },
    [theme.breakpoints.up('sm')]: {
      '& .categories-container': {
        '& .category-item-container': {
          paddingRight: '15px'
        }
      }
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: '5px',
      '& .categories-container': {
        marginLeft: '10px'
      }
    }
  })
);

export const AllCategoriesButtonContainer = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    textAlign: 'center',
    marginTop: '10px',
    '& a': {
      textDecoration: 'none',
      fontSize: '14px',
      fontWeight: 400,
      borderColor: theme.palette.primary.main,
      padding: '12px 24px 10px',
      '&:hover': {
        border: '1px solid #5fcac8',
        color: '#5fcac8',
        backgroundColor: 'transparent'
      }
    },
    [theme.breakpoints.up('sm')]: {
      '& a': {
        fontSize: '16px',
        padding: '16px 24px 14px'
      }
    }
  })
);
